import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class PaymentTerm extends Api {
  constructor(http, config = {}) {
    super(http, url, 'odoo/payment-term', config);
  }
}

